export const CREATE_APPOINTMENT = {
    REQUEST: "CREATE_APPOINTMENT_REQUEST",
    SUCCESS: "CREATE_APPOINTMENT_SUCCESS",
    FAIL: "CREATE_APPOINTMENT_FAIL",
};

export const GET_APPOINTMENTS = {
    REQUEST: "GET_APPOINTMENTS_REQUEST",
    SUCCESS: "GET_APPOINTMENTS_SUCCESS",
    FAIL: "GET_APPOINTMENTS_FAIL",
};

export const UPDATE_APPOINTMENT = {
    REQUEST: "UPDATE_APPOINTMENT_REQUEST",
    SUCCESS: "UPDATE_APPOINTMENT_SUCCESS",
    FAIL: "UPDATE_APPOINTMENT_FAIL",
};

export const DELETE_APPOINTMENT = {
    REQUEST: "DELETE_APPOINTMENT_REQUEST",
    SUCCESS: "DELETE_APPOINTMENT_SUCCESS",
    FAIL: "DELETE_APPOINTMENT_FAIL",
};
